import { useProjectField } from '@atlassian/jira-issue-field-project';
import { PROJECT_PICKER_CF_TYPE } from '@atlassian/jira-platform-field-config';
import { useGenericClipboardHandler } from '../../../clipboard-handler/utils';
import type {
	ClipboardItem,
	ListIssueFieldTransformed,
	PasteHandler,
	PasteMetadata,
} from '../../../types';
import { createClipboardHelperComponent } from '../../utils';
import type { TransformedProjectOption } from '../types';

const isTransformedProjectOption = (fieldValue: unknown): fieldValue is TransformedProjectOption =>
	fieldValue != null &&
	typeof fieldValue === 'object' &&
	'name' in fieldValue &&
	'avatarUrls' in fieldValue &&
	'key' in fieldValue;

const getPastedValue = (
	clipboardItem: ClipboardItem,
	metadata: PasteMetadata | null,
): TransformedProjectOption | null => {
	if (!clipboardItem || !metadata?.fieldValue) {
		return null;
	}
	if (!isTransformedProjectOption(metadata.fieldValue)) {
		return null;
	}

	const { name, avatarUrls, key } = metadata.fieldValue;

	return { name, avatarUrls, key };
};

const useProjectClipboardHandler: PasteHandler = (
	issue: { key: string },
	field: ListIssueFieldTransformed,
) => {
	const [, { saveValue }] = useProjectField({
		issueKey: issue.key,
		fieldKey: field?.fieldId,
	});
	return useGenericClipboardHandler(field, getPastedValue, saveValue);
};

const ProjectClipboardHelper = createClipboardHelperComponent(useProjectClipboardHandler);

export const projectClipboardHandler = {
	[PROJECT_PICKER_CF_TYPE]: ProjectClipboardHelper,
};
